import { createContext } from "react"
import type { TSession } from "@/types"

export const SessionContext = createContext<TSession | null>(null)
